<!--
 * @Description: 
 * @Version: 1.0.0
 * @Date: 2022-04-11 10:16:14
 * @LastEditors: yawen Yang
 * @LastEditTime: 2024-03-06 17:48:19
-->
<template>
  <div class="captcha"></div>
</template>

<script lang="ts" setup>
const openAliCaptcha = () => {
  return new Promise((resolve, reject) => {
    try {
      // 检查window.initAlicom4是否存在
      if (typeof (window as any).initAlicom4 !== 'function') {
        console.error('AliCaptcha: initAlicom4 not found');
        resolve(false);
        return;
      }
      
      (window as any).initAlicom4(
        {
          captchaId: "a3d0e8e1bb328a72c2257ef9f8220e72", // 请填入appId
          product: "bind",
          language:'zh-CN',
        },
        function (captchaObj: any) {
          try {
            captchaObj
              .onNextReady(function () {
                captchaObj.showCaptcha();
              })
              .onSuccess(function () {
                //your code,结合您的业务逻辑重置验证码
                var result = captchaObj.getValidate();
                resolve(result);
                captchaObj.destroy();
                
              })
              .onFail(function(){

              })
              .onError(function () {
                //your code
                captchaObj.reset();
               
                resolve(false);
              })
              .onClose(function () {
                resolve(false);
              });
          } catch (error) {
            console.error('AliCaptcha callback error:', error);
            resolve(false);
          }
        }
      );
    } catch (error) {
      console.error('AliCaptcha initialization error:', error);
      resolve(false);
    }
  });
};
defineExpose({ openAliCaptcha });
</script>
<style>

</style>
